import { PolicyLayout } from "@/components/PolicyLayout";

export default function Refunds() {
  return (
    <PolicyLayout title="Refunds & Cancellations" updated="June 2026" testId="page-refunds">
      <p>
        This Refunds &amp; Cancellations Policy explains how cancellations and refunds are handled for subscription
        purchases made on crazyOne. All amounts are processed in Indian Rupees (INR ₹) via Cashfree Payments.
      </p>

      <h2>1. Digital subscriptions</h2>
      <p>
        crazyOne subscriptions grant access to digital services for a fixed validity period (for example, monthly or
        yearly). Because access is delivered immediately upon successful payment, subscriptions are generally
        non-refundable once activated, except as described below.
      </p>

      <h2>2. Cancellation</h2>
      <ul>
        <li>You may choose not to renew a subscription at any time; access continues until the end of the current paid period.</li>
        <li>Subscriptions do not auto-renew unless explicitly stated at the time of purchase.</li>
        <li>To request a cancellation, email <a href="mailto:support@crazyone.app">support@crazyone.app</a> with your order ID.</li>
      </ul>

      <h2>3. Eligibility for refunds</h2>
      <p>A refund may be considered in the following situations:</p>
      <ul>
        <li>You were charged more than once for the same order (duplicate payment).</li>
        <li>The payment was deducted but the subscription was not activated due to a technical error.</li>
        <li>The service was not delivered as described.</li>
      </ul>

      <h2>4. How to request a refund</h2>
      <p>
        Email <a href="mailto:support@crazyone.app">support@crazyone.app</a> within <strong>7 days</strong> of the
        transaction with your order ID (format <span className="font-mono text-emerald-400">co_xxxxxxxx</span>), the registered
        phone/email used at checkout, and a description of the issue.
      </p>

      <h2>5. Processing time</h2>
      <p>
        Approved refunds are initiated within <strong>3–5 business days</strong> and credited back to the original payment
        method. Depending on your bank or card issuer, it may take an additional 5–7 business days for the amount to
        reflect in your account.
      </p>

      <h2>6. Coupons &amp; discounts</h2>
      <p>
        Where a discount coupon was applied, any refund will be limited to the actual amount paid after the discount.
      </p>

      <h2>7. Contact</h2>
      <p>
        For any refund or cancellation query, reach us at <a href="mailto:support@crazyone.app">support@crazyone.app</a>.
      </p>
    </PolicyLayout>
  );
}
